import axios from "axios"
if (localStorage.getItem("userAuthScolarite")) {
  var userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"))
  var token = userAuthScolarite.user.api_token
}
export default axios.create({
  withCredentials: true,
  baseURL: `https://flshs.scolarite.backcresus-institut.ovh/api`,
  headers: {
    Authorization: `Bearer ${token}`,
    apipassword: "3KbmGc5tZhuDbPtb",
    'X-Frame-Options': 'DENY'
  },
})
